import { render, staticRenderFns } from "./currentUserAccessDistrib.vue?vue&type=template&id=6bf70e88"
import script from "./currentUserAccessDistrib.vue?vue&type=script&lang=js"
export * from "./currentUserAccessDistrib.vue?vue&type=script&lang=js"
import style0 from "./currentUserAccessDistrib.vue?vue&type=style&index=0&id=6bf70e88&prod&lang=less"
import style1 from "./currentUserAccessDistrib.vue?vue&type=style&index=1&id=6bf70e88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports